import {createSlice} from '@reduxjs/toolkit'
import {loadState} from '@/utils/localState'
import {getAllMenuItems} from '@/helpers/getAllMenuItems'

const persistedState = loadState()?.app

const initialState = persistedState || {
  menubarOpen: false,
  mainContainerLoading: false,
  sidebarMenu: [],
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setMenubarOpen(state, action) {
      state.menubarOpen = action.payload
    },
    setMainContainerLoading: (state, action) => {
      return {
        ...state,
        mainContainerLoading: action.payload,
      }
    },
    setSidebarMenu: (state, action) => {
      return {
        ...state,
        sidebarMenu: getAllMenuItems(action.payload),
      }
    },
  },
})

export const {setMenubarOpen, setMainContainerLoading, setSidebarMenu} = appSlice.actions
export const selectMenubarOpen = (state) => state.app.menubarOpen
export const selectMainContainerLoading = (state) => state.app.mainContainerLoading
export const selectSidebarMenu = (state) => state.app.sidebarMenu

export const appReducer = appSlice.reducer
